import { render, staticRenderFns } from "./view2.vue?vue&type=template&id=375dd4b2&scoped=true"
import script from "./view2.vue?vue&type=script&lang=js"
export * from "./view2.vue?vue&type=script&lang=js"
import style0 from "./view2.vue?vue&type=style&index=0&id=375dd4b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375dd4b2",
  null
  
)

export default component.exports